export default class Customer {
  constructor(client) {
    this.client = client;
  }

  getAllCustomers(pageNumber=1, pageSize=50, from=null, to=null) {
    let url = `/customers_list?page[number]=${pageNumber}&page[size]=${pageSize}`;
    if (from && to) {
      url += `&from=${from}&to=${to}`;
    }
    return this.client.get(url);
  }

  searchCustomer(params, value) {
    return this.client.get(`/merchant/search_customers?${params}=${value}`);
  }

  // Async search for customer autocomplete - searches by name, phone, email, or loyalty ID
  // This method tries to search across multiple fields for better UX during checkout
  searchCustomersAsync(searchTerm, pageSize=20) {
    if (!searchTerm || searchTerm.trim() === '') {
      return this.client.get(`/customers_list?page[number]=1&page[size]=${pageSize}`);
    }
    
    // First, try the generic query endpoint if backend supports it
    // This should search across name, phone, email, and loyalty_id automatically
    const encodedTerm = encodeURIComponent(searchTerm);
    
    // Check if searchTerm looks like a phone number (digits only or starts with +)
    const isPhoneNumber = /^[\d+\-\s()]+$/.test(searchTerm);
    
    // Check if searchTerm looks like an email
    const isEmail = searchTerm.includes('@');
    
    // Determine the best search parameter
    let searchParam = 'name'; // default to name search
    if (isPhoneNumber) {
      searchParam = 'phone_number';
    } else if (isEmail) {
      searchParam = 'email';
    }
    
    // Use the specific parameter that the backend supports
    // This searches by: name (first_name + last_name), phone_number, or email
    // For loyalty_id, the name search often includes it in the backend
    return this.client.get(`/merchant/search_customers?${searchParam}=${encodedTerm}&page[size]=${pageSize}`);
  }

  // getAllCustomers(pageNumber=1, pageSize=1000000) {
  //   return this.client.get(`/customers_list?page[number]=${pageNumber}&page[size]=${pageSize}`);
  // }

  addNewCustomer(customerData) {
    return this.client.post("/add_user_direct", { data: customerData });
  }

  editCustomer(customerData) {
    return this.client.post(`/customers/update_customer/${customerData.id}`, {
      data: customerData,
    });
  }

  deleteCustomer(id) {///api/v2/customers/:phone_number  /customers/set_delete_flag_to_true/${id}
    return this.client.delete(`/customers/${id}`);
  }

  sendSmsToCustomer(smsData) {
    return this.client.post("/short_message_services", { data: smsData });
  }

  sendSmsToCustomerGroup(id, smsData) {
    const { message } = smsData;
    return this.client.post(`/customer_groups/${id}/send_group_message`, { message });
  }

  sendSmsToAllCustomer(smsData) {
    return this.client.post("/short_message_service_campaigns", {
      data: smsData,
    });
  }

  redeemReward(data) {
    return this.client.post(
      `/transactions/redeem_reward/${data.redemption_code}/${data.customer_id}/${data.loyalty_program_id}`,
      { quantity: 0 }
    );
  }

  assignLoyaltyIdToCustomer(data) {
    return this.client.put("/assign_loyalty_id_to_customer", data);
  }

  importCustomers(formData) {
    return this.client.post("/customers/import_customers", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  ////////////////////////////////////////////////////
  createWallet(data){
    return this.client.post("/wallet", data);
  }

  fundWallet(data){
    return this.client.patch("/wallet/fund", data);
  }

  fundWalletOverdraftLimit(data){
    return this.client.patch("/wallet/update_overdraft_limit", data);
  }

  withdrawWallet(data){
    return this.client.patch("/wallet/withdraw", data);
  }

  deleteWallet(data){
    console.log("all dat", data);
    
    return this.client.delete("/wallet", {data});
  }

  getUnpaidInvoicesBalance(customerId) {
    return this.client.get(`/customers/${customerId}/unpaid_invoices_balance`);
  }

  exportCustomers(params = {}) {
    const payload = {};
    if (params.from) payload.from = params.from;
    if (params.to) payload.to = params.to;
    return this.client.post('/customers/export_customers', payload);
  }
}
